import { useQuery } from '@tanstack/react-query';
import { getAccountInfo } from '../../../api/accounts';
import type { GetCurrentAccountInfoResponse } from '../../../types/Account';

export const useCurrentAccountData = ({
  onSuccess,
  onError,
}: {
  onSuccess?: (data: GetCurrentAccountInfoResponse) => void;
  onError?: (err: unknown) => void;
}) => {
  return useQuery({
    queryKey: ['get-current-account-info'],
    queryFn: getAccountInfo,
    onSuccess,
    onError,
    keepPreviousData: true,
    retry: false,
    staleTime: 30000,
  });
};
